import React from 'react';
import { Dropdown, DropdownButton, Col, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import MoneyUtils from '../../services/MoneyUtils';
import './style.css';

const cartTotal = (props) => (
  <Row className='cartTotalRow'>
    <Col xs={6} sm={6} md={6} lg={6} className='leftCol cartTotalName'>
      <h1 id='cart-total-title'>{props.title}</h1>
    </Col>
    <Col xs={6} sm={6} md={6} lg={6} className='rightCol dropdownMenu'>
      <DropdownButton
        id='dropdown-basic-button'
        variant='default'
        title={
          <>
            <FontAwesomeIcon
              className='cartIcon'
              icon={faShoppingCart}
              alt='Shopping Cart'
            />{' '}
            ${MoneyUtils.formatAsMoney(props.totalCost)}
          </>
        }
        size='lg'
        alignRight
      >
        <Dropdown.Item as='span' style={{ padding: 0 }}>
          <Container className='cartTotalContainer'>
            {props.cartInfo.subscription ? (
              <>
                <Row>
                  <Col xs={8} sm={8} md={8} lg={8} className='boldFont'>
                    {props.cartInfo.subscription.plan.title}
                  </Col>
                  <Col
                    xs={4}
                    sm={4}
                    md={4}
                    lg={4}
                    className='rightCol boldFont'
                  >
                    $
                    {props.cartInfo.subscription.plan.actualCostAsShipping
                      ? MoneyUtils.formatAsMoney(0)
                      : MoneyUtils.formatAsMoney(
                          props.cartInfo.subscription.plan.originalCost,
                        )}
                  </Col>
                </Row>
                <Row>
                  {props.isInfinityPlan ? (
                    <Col xs={12} sm={12} md={12} lg={12}>
                      {props.cartInfo.subscription.plan.type === 'BOX' ? (
                        <span className='left-align center-align bold link'>
                          Billed monthly.{' '}
                        </span>
                      ) : (
                        <span className='left-align center-align bold link'>
                          Billed every 21 days.{' '}
                        </span>
                      )}
                      <Link
                        to='/terms-of-service'
                        target='_blank'
                        className='mainLinks'
                      >
                        See Terms
                      </Link>
                    </Col>
                  ) : null}
                </Row>
              </>
            ) : null}
            {props.cartInfo.productsAndDetails.length
              ? props.cartInfo.productsAndDetails.map((product) => (
                  <Row key={product.product.name}>
                    <Col
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      className='cartTotalName boldFont'
                    >
                      {product.product.name}
                    </Col>
                    <Col
                      xs={4}
                      sm={4}
                      md={4}
                      lg={4}
                      className='rightCol boldFont'
                    >
                      ${MoneyUtils.formatAsMoney(product.amountToCharge)}
                    </Col>
                    <Col className='cartTotalBrand'>
                      {product.product.brand}
                    </Col>
                  </Row>
                ))
              : null}
            <hr />
            <Row>
              <Col>Subtotal</Col>
              <Col className='rightCol'>
                ${MoneyUtils.formatAsMoney(props.subTotal)}
              </Col>
            </Row>
            <Row>
              <Col>Shipping</Col>
              <Col className='rightCol'>
                ${MoneyUtils.formatAsMoney(props.shipping)}
              </Col>
            </Row>
            <Row>
              <Col>Insurance</Col>
              <Col className='rightCol'>
                ${MoneyUtils.formatAsMoney(props.shippingInsuranceCost)}
              </Col>
            </Row>
            <Row>
              <Col>Tax</Col>
              <Col className='rightCol'>
                ${MoneyUtils.formatAsMoney(props.tax)}
              </Col>
            </Row>
            {props.totalDiscount > 0 ? (
              <Row>
                <Col>Discounts</Col>
                <Col className='rightCol'>
                  {' '}
                  - ${MoneyUtils.formatAsMoney(props.totalDiscount)}
                </Col>
              </Row>
            ) : null}

            <hr />
            <Row className='totalRow'>
              <Col className='boldFont total'>Total </Col>
              <Col className='rightCol boldFont'>
                ${MoneyUtils.formatAsMoney(props.totalCost)} (USD)
              </Col>
            </Row>
          </Container>
        </Dropdown.Item>
      </DropdownButton>
    </Col>
  </Row>
);

export default React.memo(cartTotal);
